import { Outlet } from 'react-router-dom';
import './App.css';
import { AnalyticsTracker, Header } from './components';
import { Home, Login } from './pages';
import FullPageSlider from './components/FullPageSlider/FullPageSlider';
import SideMenuBar from './components/SideMenuBar/SideMenuBar';
import { useEffect, useState } from 'react';
import Toast from './components/toast/Toast';
import { useDispatch, useSelector } from 'react-redux';
import { refreshUser } from './appState/slices/auth/authSlice';
import Loader from './components/loader/Loader';
import { getBestSellerProducts, getDisplayProducts, getVaultProducts } from './appState/slices/product/productSlice';

const App = () => {
  const accessToken = localStorage.getItem('accessToken');
const loadingCount = useSelector(state => state.loader.loadingCount);
  
  const dispatch = useDispatch();
  useEffect(() => {
    if(accessToken) {
      dispatch(refreshUser(accessToken))
    }
        dispatch(getVaultProducts());
        dispatch(getDisplayProducts());
        dispatch(getBestSellerProducts());

  },[])

  return (
    <div className="App">
       {loadingCount > 0 && <Loader />}

      <AnalyticsTracker />

      <Header/>
      <Toast />
      <Outlet />
    </div>
  );
}

export default App;
